import i18next from "i18next";
import { z } from "zod";
import { proposalLineSchema } from "./proposalLineSchema";

export const proposalPdfFileSchema = z
  .instanceof(File)
  .refine(
    (file) =>
      file.type === "application/pdf" ||
      file.name.toLowerCase().endsWith(".pdf"),
    {
      message: i18next.t("serviceNegotiation.validation.invalidPdf"),
    },
  );

export const proposalSchema = z.object({
  commercialProposal: proposalPdfFileSchema,
  currency: z.string().min(1),
  lead_time: z.coerce
    .number()
    .int(i18next.t("newProposal.messages.leadTimeMustBeWholeNumber"))
    .min(1, i18next.t("newProposal.messages.leadTimeMustBePositive")),
  proposal_lines: z.array(proposalLineSchema),
  technicalProposal: proposalPdfFileSchema,
});

export type ProposalSchema = z.infer<typeof proposalSchema>;
